module.exports = __webpack_public_path__ + "resources/img/img-secuve-tos-02.6a5b0bc296a1f44d9b215c939c654c50.png";